import React from 'react';
import { NavIcon } from '../types';
import { Icon } from '../../../ui/icon';

export function renderNavIcon(
  icon: NavIcon,
  className = 'tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-current',
  color?: string
) {
  if (!icon) return null;

  if (typeof icon === 'string') {
    return <img src={icon} alt="" className={className} />;
  }

  if (typeof icon === 'function') {
    const IconComponent = icon;
    // For function components, wrap in a div to apply color if needed
    if (color) {
      return (
        <div style={{ color }} className={className}>
          <IconComponent className="tw-w-full tw-h-full" />
        </div>
      );
    }
    return <IconComponent className={className} />;
  }

  // Ensure icon size matches new admin - h-5 w-5 = 20px = 1.25rem
  // Add explicit size styles to ensure 20x20 rendering
  // When color is provided, pass it directly - the Icon component's text-current will inherit from parent
  return (
    <Icon
      icon={icon}
      className={className}
      style={{
        width: '20px',
        height: '20px',
        minWidth: '20px',
        minHeight: '20px',
        display: 'block',
        ...(color ? { color } : {}),
      }}
    />
  );
}
